import { createContext } from 'react';

// This ClientContext is used to pass a reference to the client throughout the React DOM, it is
// provided with an actual client value in `src/index.tsx`, where the client is built.
export const ClientContext = createContext<any>(null);
